/* global axios */
import ApiClient from './ApiClient';

class AiIntegrationsAPI extends ApiClient {
  constructor() {
    super('ai_integrations', { accountScoped: true });
  }

  test(id) {
    return axios.post(`${this.url}/${id}/test`);
  }

  regenerateSecret(id) {
    return axios.post(`${this.url}/${id}/regenerate_secret`);
  }
}

export default new AiIntegrationsAPI();
